import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuthStore } from '@/store/authStore'

// Frontend route guards are a UX convenience only — the backend's
// RequireRootAdmin middleware is the actual enforcement point (spec
// section 6). This just avoids flashing protected UI before redirecting.
export function ProtectedRoute() {
  const accessToken = useAuthStore((s) => s.accessToken)
  const isHydrated = useAuthStore((s) => s.isHydrated)
  const location = useLocation()

  if (!isHydrated) {
    return (
      <div className="flex h-screen items-center justify-center bg-bg text-xs text-muted">
        Checking session…
      </div>
    )
  }

  if (!accessToken) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  return <Outlet />
}
